import { FC, useEffect, useState } from "react";
import AlertComponent from "../components/AlertComponent";
import SweetAlertComponent from "../components/SweetAlertComponent";
import Header from "./appHeader/header";
import Sidebar from "./appHeader/sidebar";
import SubSidebar from "./appHeader/subSidebar";
import ProjectSidebar from "./appHeader/projectSidebar";
import TpiSidebar from "./appHeader/tpiSidebar";
import { emitter } from "../emitter";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import decryptData from "../reusable/decryptData";

interface LayoutProps {
  children: JSX.Element;
}

const LayoutContainer: FC<LayoutProps> = ({ children }) => {
  const loginUserData = decryptData();
  const [sidebarState, setSidebarState] = useState({
    showSidebar: localStorage.getItem("sidebar"),
    showProjectSidebar: localStorage.getItem("projectsidebar"),
    showTpiSidebar: localStorage.getItem("tpisidebar"),
  });

  useEffect(() => {
    const updateSidebar = (key: keyof typeof sidebarState) => (value: string) => {
      setSidebarState((prev) => ({ ...prev, [key]: value }));
    };

    emitter.on("sidebar", updateSidebar("showSidebar"));
    emitter.on("projectsidebar", updateSidebar("showProjectSidebar"));
    emitter.on("tpisidebar", updateSidebar("showTpiSidebar"));

    return () => {
      emitter.off("sidebar", updateSidebar("showSidebar"));
      emitter.off("projectsidebar", updateSidebar("showProjectSidebar"));
      emitter.off("tpisidebar", updateSidebar("showTpiSidebar"));
    };
  }, []);

  const renderSidebar = () => {
    if (sidebarState.showSidebar === "true") return <SubSidebar />;
    if (sidebarState.showProjectSidebar === "true") return <ProjectSidebar />;
    if (sidebarState.showTpiSidebar === "true") return <TpiSidebar />;
    return <Sidebar />;
  };

  return (
    <>
      <Header />
      <div className="d-flex app-header">
        {
          loginUserData?.data?.password_expire_date === null ? "" : renderSidebar()
        }
        <div className="content-width">
          <AlertComponent />
          <SweetAlertComponent />
          <div className="main-content">{children}</div>
        </div>
      </div>
    </>
  );
};

export default LayoutContainer;
